/** Feed / profile video chrome — full bar, no white patches on icons. */
export const WLJ_FEED_PLYR_OPTIONS = {
  captions: { active: true, update: true, language: "en" },
  ratio: "16:9",
  hideControls: true,
  clickToPlay: true,
  resetOnEnd: false,
  autopause: true,
  invertTime: false,
  muted: true,
  keyboard: { focused: true, global: false },
  tooltips: { controls: true, seek: true },
  fullscreen: { enabled: true, fallback: true, iosNative: true },
  controls: [
    "play-large",
    "play",
    "progress",
    "current-time",
    "mute",
    "volume",
    "captions",
    "settings",
    "pip",
    "fullscreen",
  ],
};
